// components/MapPin.js
import React, { useEffect, useState } from "react";
import "./MapPin.css";

const MapPin = ({ onClick, style = {}, imgSrc, alt = "Map Pin" }) => {
  const [tappedOnce, setTappedOnce] = useState(false);
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  useEffect(() => {
    if (tappedOnce) {
      const timer = setTimeout(() => setTappedOnce(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [tappedOnce]);

  const handleClick = () => {
    if (isMobile) {
      if (tappedOnce) {
        onClick?.();
      } else {
        setTappedOnce(true);
      }
    } else {
      onClick?.();
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      style={{ height: "50px", cursor: "pointer", userSelect: "none", ...style }}
      className={`map-pin ${tappedOnce ? "map-pin-animate" : ""}`}
      onClick={handleClick}
    />
  );
};

export default MapPin;
